import { render, staticRenderFns } from "./Bio.vue?vue&type=template&id=34ae4f59&scoped=true"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"
import style0 from "./Bio.vue?vue&type=style&index=0&id=34ae4f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ae4f59",
  null
  
)

export default component.exports